const paths = {
  listForms: '/form/list',
  editForms: '/form/edit',
  answersReportForms: '/form/answersReport',
  reportForms: '/form/report',
  reportAnswerForms: '/form/answerReport',
  reportTemplateForms: '/form/reportTemplate'
};

export default paths;
